import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import NavigationDesktop from './NavigationDesktop';
import { useState } from 'react';

import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import BarChartIcon from '@mui/icons-material/BarChart';
import HeightOutlinedIcon from '@mui/icons-material/HeightOutlined';
import ForestOutlinedIcon from '@mui/icons-material/ForestOutlined';
import OpacityOutlinedIcon from '@mui/icons-material/OpacityOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LocationCityOutlinedIcon from '@mui/icons-material/LocationCityOutlined';

import { styled, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Grid from '@mui/material/Grid';
import SvgIcon from '@mui/material/SvgIcon';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import DomainOutlinedIcon from '@mui/icons-material/DomainOutlined';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
// import Co2OutlinedIcon from '@mui/icons-material/Co2Outlined';
import ScaleOutlinedIcon from '@mui/icons-material/ScaleOutlined';
import Typography from '@mui/material/Typography';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import InfoPopup from '../info/InfoPopup';
import { Stack } from '@mui/material';
import Logo from '../logos/Logo';
import NavigationMobile from './NavigationMobile';
import NavbarMobile from './NavbarMobile';



const logoBMWSB = require('../../ressources/logos/BMWSB.png')
const logoSmartCity = require('../../ressources/logos/Logo_Smart-City-Arnsberg.png')
const logoSDG13 = require('../../ressources/logos/E_WEB_INVERTED_13.png')
const logoSDG15 = require('../../ressources/logos/E_WEB_INVERTED_15.png')

interface NavigationProps {
    setLayerSelection: Function,
    layerSelection: any,
    setSelectedPolygonId: Function,
    setDashboardData: Function,
    setDashboardOpen: Function,
    setInfoPopup: Function,
    // setNavbarMobileOpen: Function,
    // navbarMobileOpen: boolean
}

export default function Navigation({
    setLayerSelection,
    layerSelection,
    setSelectedPolygonId,
    setDashboardData,
    setDashboardOpen,
    setInfoPopup,}: NavigationProps) {

    function resetDashboard() {
        setDashboardData([])
        setDashboardOpen(false)
        setSelectedPolygonId("")
    }

    // mobile
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [navbarMobileOpen, setNavbarMobileOpen] = useState(false)


    // tablet
    const tablet = useMediaQuery(theme.breakpoints.down('lg'));


    function handleLayerSelectionClick(layer: string) {
        // Check if layer is in name of listItemsFlaeche
        // if yes, set layer1
        // if no, set layer2
        if (listItemsFlaeche.find(item => item.name === layer)) {
            setLayerSelection({ ...layerSelection, layer1: layer })
            resetDashboard()
        } else {
            setLayerSelection({ ...layerSelection, layer2: layer })
        }

    }

    const handleChange = (event: SelectChangeEvent) => {
        setLayerSelection({ ...layerSelection, period: event.target.value as string })
        // setSelectedPolygonId("")
    };

    const ListItemStyled = (props: any) => (
        //List item button shape with edges rounded

        <ListItem button onClick={props.handleClick} selected={props.selected}

            sx={{
                borderRadius: '6px',

                '&:hover': {
                    cursor: 'pointer',
                    color: 'black',
                    '& .listIcon': {
                        color: 'black',
                    },
                    // backgroundColor: '#E0E5E7'

                },
                '&.Mui-selected': {
                    color: 'black',
                    '& .listIcon': {
                        color: 'black',
                    },
                    boxShadow: 2,

                    backgroundColor: theme.palette.buttonBackground.main,
                }

            }}>
            {props.children}
        </ListItem >
    );

    const ListItemTextStyled = (props: any) => (
        <ListItemText
            primary={props.label}
            primaryTypographyProps={{ fontSize: '15px' }}

        />
    );

    const listItemsFlaeche = [
        { name: "ARNSBERG", label: "Arnsberg", icon: <LocationCityOutlinedIcon /> },
        { name: "FLURSTUECKFLAECHEN", label: "Flurstücke", icon: <DomainOutlinedIcon /> },
        { name: "FORSTEINRICHTUNGSFLAECHEN", label: "Stadtwald Arnsberg", icon: <TimelineOutlinedIcon /> }]
    const listItemsWaldInformationen = [
        { name: "WALDARTEN", label: "Waldtypen 2016", icon: <DonutLargeIcon /> },
        { name: "BAUMHOEHE", label: "Baumhöhe 2020/21", icon: <HeightOutlinedIcon /> },
        { name: "BIOMASSE", label: "Biomasse 2020/21", icon: <ScaleOutlinedIcon /> },
        { name: "KOHLENSTOFFGEHALT", label: "Kohlenstoffgehalt 2020/21", icon: <BarChartOutlinedIcon /> }
    ]
    const listItemsWaldzustand = [
        { name: "WALDVITALITAET", label: "Wald-Vitalität", icon: <OutlinedForestIcon /> },
        { name: "WASSERDEFIZIT", label: "Laubwald Wasserhaushalt", icon: <OpacityOutlinedIcon /> },
        { name: "SCHADFLAECHEN", label: "Schadflächen", icon: <TrendingDownIcon /> }
    ]

    function handleInfoClick(type: string, title: string) {
        console.log("Info clicked", type)
        setInfoPopup({
            open: true,
            id: type,
            title: title
        })
    }

    interface ListTitleProps {
        text: string,
        type: string
    }

    function ListTitle({ text, type }: ListTitleProps) {
        return (
            <Grid container direction="row" alignItems="center" justifyContent="flex-start" sx={{ ml: 1, mb: 1 }}>
                <Grid>
                    <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '16px' }}>

                        {text}
                    </Typography>
                </Grid>
                <Grid item >
                    <Grid item container alignItems="center">
                        <ListItemIcon
                            sx={{ pl: 1, "&:hover": { cursor: "pointer" } }} onClick={() => handleInfoClick(type, text)}
                        >
                            <InfoOutlinedIcon />
                        </ListItemIcon>
                    </Grid>
                </Grid>
            </Grid>
        )


    }
    const MarginBottom = (props: any) => (
        <Box sx={{ mb: 3 }}></Box>
    );


    const content = (<>
        <List sx={{ m: 2 }}>

            <ListTitle text="Flächenauswahl" type="FLAECHENAUSWAHL" />

            {listItemsFlaeche.map((item, index) => {
                //Highlight list item if layer is selected
                return (
                    <ListItemStyled handleClick={() => { handleLayerSelectionClick(item.name) }} key={index} selected={layerSelection.layer1 === item.name}
                    >
                        <ListItemIcon className='listIcon'>
                            {item.icon}
                        </ListItemIcon>
                        <ListItemTextStyled
                            label={item.label} />
                    </ListItemStyled>
                )
            })}
            <MarginBottom />

            <ListTitle text="Waldinformationen" type="WALDINFORMATIONEN" />

            {listItemsWaldInformationen.map((item, index) => {
                return <ListItemStyled handleClick={() => { handleLayerSelectionClick(item.name) }} key={index} selected={layerSelection.layer2 === item.name}>
                    <ListItemIcon className='listIcon'>
                        {item.icon}
                    </ListItemIcon>
                    <ListItemTextStyled
                        label={item.label} />
                </ListItemStyled>
            })}
            <MarginBottom />
            {/* // make the mouse cursor to a pointer when ListItemIcon is hover */}

            <Grid container direction="row" justifyContent="center"
                alignItems="center">
                <Grid item md={6.7} container direction="row">

                    <ListTitle text="Waldzustand" type="WALDZUSTAND" />
                </Grid>

                <Grid item md={5.3} >
                    <FormControl size="small" sx={{ width: 134 }}>
                        <InputLabel id="demo-simple-select-label">Zeitraum</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={layerSelection.period}
                            label="Zeitraum"
                            onChange={handleChange}
                        >
                            <MenuItem value="2016_2020">2016 - 2020</MenuItem>
                            <MenuItem value="2020_2021">2020 - 2021</MenuItem>
                            <MenuItem value="2021_2022">2021 - 2022</MenuItem>
                            <MenuItem value="2022_2023">2022 - 2023</MenuItem>
                            <MenuItem value="2023_2024">2023 - 2024</MenuItem>
                            <MenuItem value="2024_2025">2024 - 2025</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                {/* <Grid item md={2}>
                    <></>
                </Grid> */}
            </Grid>
            <Box sx={{ mb: 1 }} />
            {listItemsWaldzustand.map((item, index) => {
                return (
                    <ListItemStyled handleClick={() => { handleLayerSelectionClick(item.name) }} key={index} selected={layerSelection.layer2 === item.name}>
                        <ListItemIcon className='listIcon'>
                            {item.icon}
                        </ListItemIcon>
                        <ListItemTextStyled
                            label={item.label} />
                    </ListItemStyled>
                )
            })
            }
            <Box sx={{ mb: 5 }} />
            <LogosComponent />
            {tablet && <Box sx={{ mb: 5 }} />}
        </List>

    </>)

    return (
        <>
            {mobile ?
                <>

                    <NavbarMobile setNavbarMobileOpen={setNavbarMobileOpen} />
                    {navbarMobileOpen && <NavigationMobile navbarMobileOpen={navbarMobileOpen} setNavbarMobileOpen={setNavbarMobileOpen} >
                        {content}
                    </NavigationMobile>
                    }
                </>
                :
                <NavigationDesktop >
                    {content}
                </NavigationDesktop>
            }
        </>

    )
}



function OutlinedForestIcon() {
    return (<>
        <SvgIcon>
            <svg
                id="b"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 128 95.81"
            >
                <g id="c">
                    <path d="M128,77.96h-36.29v17.84h-6.89v-25.03h29.28l-22.63-32.81h10.78l-17.37-24.67-.06,.09V.08l.06-.08,31.86,45.15h-11.38l22.63,32.81Zm-51.98-3.89c-1.48,1.48-3.05,2.77-4.7,3.89h6.62v17.84h6.89v-25.03h-5.96c-.87,1.14-1.79,2.25-2.84,3.3Zm-7.72-50.75c.32,.98,.61,1.97,.83,2.99,1.58,.84,3.02,1.85,4.4,2.94l11.24-15.97,.06,.09V.08l-.06-.08-16.46,23.33Zm-23.62,72.48v-18.16h10.03c6.88,0,12.75-2.42,17.6-7.27,4.85-4.85,7.27-10.72,7.27-17.6,0-4.97-1.37-9.55-4.1-13.74-2.74-4.19-6.42-7.23-11.07-9.14-.75-6.22-3.46-11.42-8.15-15.61-4.68-4.19-10.18-6.28-16.48-6.28s-11.79,2.09-16.48,6.28c-4.68,4.19-7.4,9.39-8.15,15.61-4.64,1.91-8.33,4.95-11.07,9.14C1.37,43.23,0,47.81,0,52.78c0,6.88,2.42,12.75,7.27,17.6,4.85,4.85,10.72,7.27,17.6,7.27h9.84v18.16h9.98ZM12.56,65.09c-3.4-3.4-5.1-7.5-5.1-12.31,0-3.48,.99-6.65,2.98-9.51,1.99-2.86,4.56-4.99,7.71-6.4l3.98-1.74,.5-4.35c.58-4.39,2.49-8.04,5.72-10.94,3.23-2.9,7.05-4.35,11.44-4.35s8.21,1.45,11.44,4.35c3.23,2.9,5.14,6.55,5.72,10.94l.5,4.35,3.98,1.74c3.15,1.41,5.72,3.54,7.71,6.4,1.99,2.86,2.98,6.03,2.98,9.51,0,4.81-1.7,8.91-5.1,12.31-3.4,3.4-7.5,5.1-12.31,5.1H24.87c-4.81,0-8.91-1.7-12.31-5.1Z" />
                </g>
            </svg>
        </SvgIcon>
    </>)
}

function LogosComponent(props: any) {

    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('sm'));




    return (
        //Add a Typography component that lies above the logos with a bit of padding and the text "Entwcihelt von:"
        <>
            {/* <Typography variant="body1" sx={{
                position: "fixed",
                bottom: 70,
                textAlign: "center",
                paddingBottom: 5,
                paddingLeft: 3,
            }}>
                Unterstützt durch:
            </Typography> */}

            <ListItem sx={{
                // position: "absolute",
                bottom: 0,
                pt: 3,
                textAlign: "center",
                // paddingBottom: 2,
                paddingLeft: 2,
            }}>

                <Stack direction="row" spacing={2.5} justifyContent="flex-start">
                    <Stack spacing={2}>
                        <Logo width='100px' imageSource={logoSmartCity} urlClick="https://www.arnsberg.de/smart-city/das-modellprojekt/projektportfolio" />
                        <Stack
                            // container
                            direction="row"
                            // justifyContent="center"
                            alignItems="flex-start"
                            spacing={1}
                        >
                            <Logo width='50px' imageSource={logoSDG13} urlClick="https://www.bmz.de/de/agenda-2030/sdg-13" />
                            <Logo width='50px' imageSource={logoSDG15} urlClick="https://www.bmz.de/de/agenda-2030/sdg-15" />
                        </Stack>
                    </Stack>
                    {/* <Box sx={{pb:2}}> */}
                    <Logo width='120px' imageSource={logoBMWSB} urlClick="https://www.bmwsb.bund.de/Webs/BMWSB/DE/startseite/startseite-node.html" />

                    {/* </Box> */}
                </Stack>
            </ListItem>
        </>
    )

}